module.exports = __webpack_public_path__ + "img/brand-coin.473397da.svg";